var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#081132",
    fillRule: "evenodd",
    d: "M8.96 0H9c.677.022 1.22.577 1.22 1.26 0 .682-.543 1.238-1.22 1.26v.004H5.146c-1.448 0-2.622 1.174-2.622 2.622v9.708c0 1.448 1.174 2.622 2.622 2.622H9v.005c.677.02 1.22.576 1.22 1.259 0 .683-.543 1.238-1.22 1.26H5.146C2.304 20 0 17.696 0 14.854V5.146C0 2.304 2.304 0 5.146 0H8.96zM6.52 9.97c0-.691.56-1.25 1.25-1.25h7.935l-1.022-1.023c-.489-.488-.489-1.28 0-1.768.488-.488 1.28-.488 1.768 0l3.181 3.182c.385.385.467.957.245 1.422-.06.13-.143.251-.25.358l-3.182 3.182c-.488.489-1.28.489-1.768 0-.488-.488-.488-1.28 0-1.767l1.086-1.087H7.77c-.69 0-1.25-.56-1.25-1.25z",
    clipRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.289878e8.svg";
export { ForwardRef as ReactComponent };